import {ISelectItem} from '~/components/Controls/Select';
import {ID} from '~/lib/model';
import {Configuration} from '~/modules/Clients/models/Configuration';

export enum Operation {
    UPDATE,
    CREATE,
    DELETE
}

export enum Target {
    SOURCES,
    SELLERS
}

export const operations: ISelectItem<Operation>[] = [
    {label: 'Create', value: Operation.CREATE},
    {label: 'Update', value: Operation.UPDATE},
    {label: 'Delete', value: Operation.DELETE}
];

export const targets: ISelectItem<Target>[] = [
    {label: 'Sellers', value: Target.SELLERS},
    {label: 'Source', value: Target.SOURCES}
];

export const defaultConfigsManipulation: IConfigsManipulation = {
    sellerIds: [],
    target: Target.SOURCES,
    operation: Operation.CREATE,
    keys: [],
    configuration: ''
};

export interface IConfigsManipulation {
    sellerIds: ID[];
    target: Target;
    operation: Operation;
    keys: string[];
    configuration: Configuration;
}
